export const ConsumerNameFormUat = {
  submitButton: 'workflow.consumerName.submitButton',
}
